"use client";
import Link from "next/link";
import { FaGithub, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import Image from "next/image";

const footerLinks = [
  {
    title: "CI Runners",
    links: [
      { href: "/products/ci/cloud-runners", label: "Cloud Runners" },
      { href: "/products/ci/arm64-runners", label: "ARM64 Runners" },
      { href: "/products/ci/x86-runners", label: "x86-64 Runners" },
      { href: "/products/ci/macos-runners", label: "macOS Runners" },
      { href: "/products/ci/windows-runners", label: "Windows Runners" },
    ],
  },
  {
    title: "Caching and Builds",
    links: [
      { href: "/products/ci/cache", label: "Unlimited Caching" },
      { href: "/products/ci/docker-layer-caching", label: "Docker Layer Cache" },
      { href: "/products/ci/docker-builders", label: "Docker Builders" },
    ],
  },
  {
    title: "BYOC",
    links: [
      { href: "/products/ci/byoc", label: "Bring Your Own Cloud" },
      { href: "/products/ci/byoc/aws", label: "BYOC AWS" },
      { href: "/products/ci/byoc/gcp", label: "BYOC GCP" },
      { href: "/products/ci/byoc/azure", label: "BYOC Azure" },
      { href: "/pricing", label: "Pricing" },
    ],
  },
  {
    title: "Resources",
    links: [
      { href: "https://docs.warpbuild.com", label: "Docs", openInNewTab: true },
      {
        href: "https://www.warpbuild.com/blog",
        label: "Blog",
        openInNewTab: true,
      },
      {
        href: "https://compliance.warpbuild.com/",
        label: "Trust Center",
        openInNewTab: true,
      },
      {
        href: "https://docs.warpbuild.com/ci/security",
        label: "Security",
        openInNewTab: true,
      },
      { href: "/brand-assets", label: "Brand Assets" },
    ],
  },
  {
    title: "Enterprise",
    links: [
      { href: "/products/enterprise", label: "Enterprise Benefits" },
      { href: "/products/security", label: "Security and Access Control" },
    ],
  },
  {
    title: "Company",
    links: [
      { href: "/about", label: "About Us" },
      {
        href: "https://warpbuild.getrewardful.com/signup",
        label: "WarpBuild Affiliates",
        openInNewTab: true,
      },
      {
        href: "https://cal.com/suryao/start",
        label: "Schedule a Call",
        openInNewTab: true,
      },
    ],
  },
  {
    title: "Legal",
    links: [
      { href: "/legal/privacy", label: "Privacy Policy" },
      { href: "/legal/subprocessors", label: "Subprocessors" },
      { href: "/legal/terms", label: "Terms of Service" },
    ],
  },
  {
    title: "Benchmarks",
    links: [
      {
        href: "/compare/github",
        label: "Github vs WarpBuild",
      },
      // {
      //   href: "/compare/depot",
      //   label: "Depot vs WarpBuild",
      // },
      // {
      //   href: "/compare/blacksmith",
      //   label: "Blacksmith vs WarpBuild",
      // },
    ],
  },
];

export function Footer() {
  return (
    <footer className="relative text-white py-12 bg-[radial-gradient(circle_at_center_top,#141414_0%,#080808_35%)]">
      <div className="absolute top-0 left-0 right-0 h-px bg-border-default" />
      <div className="container mx-auto lg:px-12 px-12 max-w-custom">
        <div className="flex flex-wrap justify-between items-center mb-12">
          <div className="w-full md:w-auto mb-6 md:mb-0">
            <Link
              href="/"
              className="text-2xl font-bold flex items-center mb-6"
            >
              <Image
                src="/images/logo.svg"
                alt="WarpBuild Logo"
                width={220}
                height={120}
                className="mr-2"
                quality={100}
              />
            </Link>
            <div className="flex space-x-6">
              {[
                {
                  href: "https://twitter.com/WarpBuilds",
                  Icon: FaXTwitter,
                  alt: "WarpBuild Twitter",
                },
                {
                  href: "https://github.com/WarpBuilds",
                  Icon: FaGithub,
                  alt: "WarpBuild GitHub",
                },
                {
                  href: "https://www.linkedin.com/company/warpbuild/",
                  Icon: FaLinkedin,
                  alt: "WarpBuild LinkedIn",
                },
              ].map(({ href, Icon, alt }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-icon-secondary-default hover:text-icon-secondary-hover transition duration-150"
                  aria-label={alt}
                >
                  <Icon className="w-5 h-5" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
          <div className="flex felx-col gap-6 w-full md:w-auto">
            <iframe
              title="WarpBuild status"
              src="https://warpbuild.instatus.com/embed-status/3bbe4bb3/dark-sm"
              id="status"
              width="230"
              height="40"
              frameBorder="0"
              scrolling="no"
              style={{ border: "none" }}
            />
            <Link href="https://compliance.warpbuild.com/" target="_blank">
              <Image
                src="/images/soc2-og.svg"
                alt="soc2 type 2"
                width={44}
                height={44}
                quality={100}
              />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="font-medium mb-5">{section.title}</h3>
              <ul className="space-y-3 text-sm">
                {section.links.map((link) => (
                  <li key={link.href}>
                    {link.openInNewTab ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-text-link-nav-default hover:text-text-link-nav-hover transition duration-150"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        href={link.href}
                        className="text-text-link-nav-default hover:text-text-link-nav-hover transition duration-150"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-4 text-xs text-right text-text-body-secondary border-t border-border-default">
          © WarpBuild {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
}
